"use client";

import { c as _c } from "react/compiler-runtime";
import type { MouseEvent } from "react";
import { useCallback } from "react";
import { useRouter } from "next/navigation";
import type { ApiWave } from "@/generated/models/ApiWave";
import { numberWithCommas } from "@/helpers/Helpers";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
export default function WaveItemDropped(t0) {
  const $ = _c(23);
  const {
    wave
  } = t0;
  let t1;
  if ($[0] !== wave.contributors_overview) {
    t1 = wave.contributors_overview ?? [];
    $[0] = wave.contributors_overview;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contributors = t1;
  const router = useRouter();
  let t2;
  if ($[2] !== router) {
    t2 = href => event => {
      if (event.metaKey || event.ctrlKey) {
        event.preventDefault();
        event.stopPropagation();
        window.open(href, "_blank", "noopener,noreferrer");
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      router.push(href);
    };
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleContributorClick = t2;
  const handleContributorAuxClick = _temp;
  let t3;
  if ($[4] !== contributors || $[5] !== handleContributorClick) {
    let t4;
    if ($[7] !== handleContributorClick) {
      t4 = (c, index) => {
        const baseKey = `${c.contributor_identity ?? "anon"}-${c.contributor_pfp ?? "no-pfp"}-${index}`;
        const contributorHref = c.contributor_identity ? `/${c.contributor_identity}` : undefined;
        const avatar = <div className="tw-h-6 tw-w-6">{c.contributor_pfp ? <img className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-700 tw-ring-[1.5px] tw-ring-black tw-transition tw-duration-200 tw-ease-out desktop-hover:group-hover/item:tw-brightness-110 desktop-hover:group-hover/item:tw-scale-[1.05]" src={getScaledImageUri(c.contributor_pfp, ImageScale.W_AUTO_H_50)} alt={c.contributor_identity ? `${c.contributor_identity} avatar` : "Contributor avatar"} loading="lazy" decoding="async" /> : <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-rounded-md tw-bg-iron-700 tw-ring-1 tw-ring-black"><span className="tw-text-[0.625rem] tw-font-semibold tw-text-iron-300">{c.contributor_identity?.slice(0, 2).toUpperCase() ?? "?"}</span></div>}</div>;
        return <div key={baseKey} className="tw-block tw-group/item">{contributorHref ? <button type="button" data-wave-item-interactive="true" onClick={handleContributorClick(contributorHref)} onAuxClick={handleContributorAuxClick(contributorHref)} className="tw-cursor-pointer tw-bg-transparent tw-border-none tw-p-0 tw-m-0 tw-inline-flex" aria-label={c.contributor_identity ? `View @${c.contributor_identity}` : "View contributor profile"}>{avatar}</button> : avatar}</div>;
      };
      $[7] = handleContributorClick;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = contributors.map(t4);
    $[4] = contributors;
    $[5] = handleContributorClick;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="tw-hidden @[320px]/wave:tw-flex tw-items-center -tw-space-x-1 tw-flex-shrink">{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== wave.metrics.drops_count) {
    t5 = numberWithCommas(wave.metrics.drops_count);
    $[11] = wave.metrics.drops_count;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <span className="tw-text-white tw-font-medium tw-text-sm tw-flex-shrink-0">{t5}</span>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = wave.metrics.drops_count === 1 ? "Drop" : "Drops";
  let t8;
  if ($[15] !== t7) {
    t8 = <span className="tw-text-iron-500 tw-font-normal tw-truncate tw-min-w-0">{t7}</span>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-x-1 tw-text-sm tw-min-w-0">{t6}{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t4 || $[21] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-min-w-0">{t4}{t9}</div>;
    $[20] = t4;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp(href_0) {
  return event_0 => {
    if (event_0.button !== 1) {
      return;
    }
    event_0.preventDefault();
    event_0.stopPropagation();
    window.open(href_0, "_blank", "noopener,noreferrer");
  };
}